import React from 'react';
import { useLocation } from 'react-router-dom';
import './MainContent.css';

const MainContent = ({ children }) => {
  const location = useLocation();
  const isBuilderPage = location.pathname.includes('/builderjs-email-builder') || 
                       location.pathname.includes('/new-builderjs');
  
  return (
    <main className={`main-content ${isBuilderPage ? 'builder-page-container' : ''}`}>
      {children}
    </main>
  );
};

export default MainContent;
